<!-- 调店审核 -->
<template>
  <div class="page">
    <div class="p16 flex-row">
      <div>
        <span class="cur" @click="back"><i class="el-icon-arrow-left"></i>返回</span>
        <el-divider direction="vertical"  class="color999"></el-divider>
        <span class="color999 cur" @click="back">IC卡转会员&nbsp;/&nbsp;</span>
      </div>
      <div>转卡记录</div>
    </div>
    <div class="page-head ">
      <div class="mains-content ">
        <div class="member-content-box br10">
          <div class="member-header space-between mb16">
            <div class="flex-row">
              <el-input v-model="query.keyword" placeholder="请输入ic卡号/手机号码/姓名" maxlength="11" class="mr10"></el-input>
              <el-button type="primary" class="small-btn" @click="doData">搜索</el-button>
            </div>
          </div>
          <el-table :data="list" :max-height="height - 266" header-cell-class-name="table_header_bgcolor">
            <el-table-column prop="username" label="姓名" width="auto"></el-table-column>
            <el-table-column prop="cardLogicno" label="ic卡号" width="auto"></el-table-column>
            <el-table-column prop="turnStatusCn" label="转卡状态" width="auto"></el-table-column>
            <el-table-column prop="mobile" label="手机号码" width="auto"></el-table-column>
            <el-table-column prop="amount" label="金额" width="auto"></el-table-column>
            <el-table-column prop="auditStatusCn" label="审核状态" width="auto"></el-table-column>
            <el-table-column prop="turnDate" label="转卡时间" width="160">
              <template slot-scope="scope">
                {{formatDate(scope.row.turnDate)}}
              </template>
            </el-table-column>
            <el-table-column prop="amt" label="操作" align="left" fixed="right" width="80">
              <template slot-scope="scope">
                <el-link type="primary" @click="DetailPage(scope.row)">详情</el-link>
              </template>
            </el-table-column>
          </el-table>
          <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
        </div>
      </div>
    </div>
    <detail-set ref="detailSetForm"></detail-set>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import detailSet from "./detail";
export default {
  data() {
    return {
      query: {
        keyword: "",
        start: 0,
        size: 20
      },
      url: this.$url.icCardRecord.list,
      list: [],
      options: [],
      height: this.$store.getters.MainHeight
    };
  },
  mixins: [minxin],
  components: { detailSet },
  computed: {},

  created() {
    this.totalCounts();
  },

  methods: {
    DetailPage (row) {
      this.$refs["detailSetForm"].$emit("set", row);
    },
    totalCounts () {
      this.$api.post(this.$url.icCardRecord.count, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => {});
    },
    back () {
      this.$router.push("/collectMoney/icCard");
    },
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.page-head {
  height: 100%;
  .member-content-box {
    background: #fff; 
    padding: 16px 16px 0;
  }
}

.mains-content {

}
</style>

